import React, { useEffect, useState } from "react";
import AdminLayout from "./Common/AdminLayout";
import { useDispatch, useSelector } from "react-redux";
import { FaUser, FaEnvelope, FaPhone, FaEye, FaEyeSlash } from "react-icons/fa";
import { GetUser, UpdateUser } from "../../Redux/Slices/User";
import toast from "react-hot-toast";
import "../../asset/new/css/admin-modern.css";

const AdminProfile = () => {
  const { userData } = useSelector((state) => state?.User);
  const [isRevealPwd, setIsRevealPwd] = useState(false);
  const [isRevealPwd2, setIsRevealPwd2] = useState(false);
  const [newPass, setNewPass] = useState("");
  const [confirmPass, setConfirmPass] = useState("");
  const [error, setError] = useState("");
  let id = localStorage.getItem("id");
  const dispatch = useDispatch();

  //Password Reset Handle
  const handlePasswordReset = async (e) => {
    e.preventDefault();
    let id = localStorage.getItem("id");

    // Check if fields are empty
    if (!newPass || !confirmPass) {
      setError("Please fill in both password fields");
      toast.error("Please fill in both password fields");
      return;
    }

    // Check if passwords match
    if (newPass !== confirmPass) {
      setError("Passwords don't match");
      toast.error("Passwords don't match");
      return;
    }

    // Check password length or other requirements if needed
    if (newPass.length < 6) {
      setError("Password should be at least 6 characters");
      toast.error("Password should be at least 6 characters");
      return;
    }

    try {
      let newPassword = { password: newPass };
      await dispatch(UpdateUser(id, newPassword));
      setError("");
      setNewPass("");
      setConfirmPass("");
      toast.success("Password updated successfully");
    } catch (error) {
      setError("Failed to update password");
      toast.error("Failed to update password");
    }
  };

  useEffect(() => {
    dispatch(GetUser(id));
    document.title = "Profile | Admin";
  }, []);

  return (
    <AdminLayout
      title="My Profile"
      subtitle="Manage your account settings"
      breadcrumbs={[
        { label: "Dashboard", active: false },
        { label: "Profile", active: true }
      ]}
    >
      <div className="admin-grid admin-grid-cols-2 admin-gap-lg">
        {/* Contact Information Card */}
        <div className="admin-card">
          <div className="admin-card-header">
            <h3 className="admin-card-title">Contact Information</h3>
          </div>
          <div className="admin-card-body">
            <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--spacing-lg)' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--spacing-md)' }}>
                <div
                  style={{
                    width: '48px',
                    height: '48px',
                    borderRadius: 'var(--radius-full)',
                    background: 'var(--admin-primary-lighter)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'var(--admin-primary)'
                  }}
                >
                  <FaUser size={20} />
                </div>
                <div>
                  <div style={{ fontSize: '0.875rem', color: 'var(--admin-text-muted)', marginBottom: '0.25rem' }}>
                    Full Name
                  </div>
                  <div style={{ fontSize: '1rem', fontWeight: 500, color: 'var(--admin-text-primary)' }}>
                    {userData?.name || "N/A"}
                  </div>
                </div>
              </div>

              <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--spacing-md)' }}>
                <div
                  style={{
                    width: '48px',
                    height: '48px',
                    borderRadius: 'var(--radius-full)',
                    background: 'var(--admin-info-light)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'var(--admin-info)'
                  }}
                >
                  <FaEnvelope size={20} />
                </div>
                <div>
                  <div style={{ fontSize: '0.875rem', color: 'var(--admin-text-muted)', marginBottom: '0.25rem' }}>
                    Email Address
                  </div>
                  <div style={{ fontSize: '1rem', fontWeight: 500, color: 'var(--admin-text-primary)' }}>
                    {userData?.email || "N/A"}
                  </div>
                </div>
              </div>

              <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--spacing-md)' }}>
                <div
                  style={{
                    width: '48px',
                    height: '48px',
                    borderRadius: 'var(--radius-full)',
                    background: 'var(--admin-success-light)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'var(--admin-success)'
                  }}
                >
                  <FaPhone size={20} />
                </div>
                <div>
                  <div style={{ fontSize: '0.875rem', color: 'var(--admin-text-muted)', marginBottom: '0.25rem' }}>
                    Phone Number
                  </div>
                  <div style={{ fontSize: '1rem', fontWeight: 500, color: 'var(--admin-text-primary)' }}>
                    {userData?.mobile || "N/A"}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Change Password Card */}
        <div className="admin-card">
          <div className="admin-card-header">
            <h3 className="admin-card-title">Change Password</h3>
          </div>
          <div className="admin-card-body">
            <form onSubmit={handlePasswordReset}>
              {error && (
                <div
                  style={{
                    padding: 'var(--spacing-md)',
                    background: 'var(--admin-danger-light)',
                    color: 'var(--admin-danger)',
                    borderRadius: 'var(--radius-md)',
                    marginBottom: 'var(--spacing-lg)',
                    fontSize: '0.875rem'
                  }}
                >
                  {error}
                </div>
              )}

              <div className="admin-form-group">
                <label className="admin-form-label admin-form-label-required">
                  New Password
                </label>
                <div style={{ position: 'relative' }}>
                  <input
                    type={isRevealPwd ? "text" : "password"}
                    className="admin-form-input"
                    placeholder="Enter new password"
                    value={newPass}
                    onChange={(e) => setNewPass(e.target.value)}
                    required
                  />
                  <button
                    type="button"
                    onClick={() => setIsRevealPwd(!isRevealPwd)}
                    style={{
                      position: 'absolute',
                      right: '12px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      background: 'transparent',
                      border: 'none',
                      cursor: 'pointer',
                      color: 'var(--admin-text-muted)',
                      padding: '4px'
                    }}
                  >
                    {isRevealPwd ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
              </div>

              <div className="admin-form-group">
                <label className="admin-form-label admin-form-label-required">
                  Confirm Password
                </label>
                <div style={{ position: 'relative' }}>
                  <input
                    type={isRevealPwd2 ? "text" : "password"}
                    className="admin-form-input"
                    placeholder="Confirm new password"
                    value={confirmPass}
                    onChange={(e) => setConfirmPass(e.target.value)}
                    required
                  />
                  <button
                    type="button"
                    onClick={() => setIsRevealPwd2(!isRevealPwd2)}
                    style={{
                      position: 'absolute',
                      right: '12px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      background: 'transparent',
                      border: 'none',
                      cursor: 'pointer',
                      color: 'var(--admin-text-muted)',
                      padding: '4px'
                    }}
                  >
                    {isRevealPwd2 ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
              </div>

              <button
                type="submit"
                className="admin-btn admin-btn-primary"
                disabled={!newPass || !confirmPass}
                style={{ width: '100%' }}
              >
                Update Password
              </button>
            </form>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default AdminProfile;